import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { Route, useRouteMatch } from 'react-router-dom';
import { postDataPromise } from 'brock-fetch-utils';
import {
    HighlightedSection,
    Title,
    Fields,
    SingleSelect,
    AnimatedPageLoader,
    HorizontalFlex,
    PadContainer,
} from 'smartsuite-ui';
import FlightList from './FlightList';
import BagLocations from './BagLocations';
import getUri from '../../utils/getUri';

function fetchSelectOptions() {
    return postDataPromise(getUri(`SelectOptionApi/GetCriteriaValues`), [
        'SmartBag.DataWarehouseAirline',
        'enterprise.dataWarehouseAllStationCode',
        'SmartBag.DataWarehouseTerminal',
    ]);
}

export default function App(props) {
    let { path } = useRouteMatch();
    const flightStatusTranslation = useTranslation('flightStatus');
    const labels = flightStatusTranslation.t('flightStatus', {
        returnObjects: true,
    });
    document.title = labels.title;

    const { isLoading, isError, data, error } = useQuery(
        'selectOptions',
        fetchSelectOptions
    );

    const [selectedAirline, setSelectedAirline] = useState({
        id: '',
        description: '',
    });

    const [selectedStation, setSelectedStation] = useState({
        id: '',
        description: '',
    });

    const [selectedTerminal, setOutboundTerminal] = useState({
        id: '',
        description: '',
    });

    if (isLoading) {
        return <AnimatedPageLoader />;
    }

    if (isError) {
        return error.message;
    }

    const airlineOptions =
        data.find((x) => x.fieldName === 'SmartBag.DataWarehouseAirline')
            ?.options ?? [];

    const stationOptions =
        data.find(
            (x) => x.fieldName === 'enterprise.dataWarehouseAllStationCode'
        )?.options ?? [];

    const outboundTerminalOptions =
        data.find((x) => x.fieldName === 'SmartBag.DataWarehouseTerminal')
            ?.options ?? [];

    return (
        <div className="app-container">
            <Title>{labels.title}</Title>
            <Fields>
                <SingleSelect
                    label="Outbound Terminal"
                    value={selectedTerminal}
                    onChange={(value) => {
                        setOutboundTerminal(value);
                        props.history.push('/FlightStatus');
                    }}
                    options={outboundTerminalOptions}
                    valueField="id"
                    textField="description"
                />
                <SingleSelect
                    label="Airline Code"
                    value={selectedAirline}
                    onChange={(value) => {
                        setSelectedAirline(value);
                        props.history.push('/FlightStatus');
                    }}
                    options={airlineOptions}
                    valueField="id"
                    textField="description"
                />
                <SingleSelect
                    label="Destination Station"
                    value={selectedStation}
                    onChange={(value) => {
                        setSelectedStation(value);
                        props.history.push('/FlightStatus');
                    }}
                    options={stationOptions}
                    valueField="id"
                    textField="description"
                />
            </Fields>
            <PadContainer cssClassModifiers={['pad-small']} />
            <HighlightedSection>
                <PadContainer>
                    <HorizontalFlex cssClassModifiers={['align-flex-start']}>
                        <FlightList
                            airlineCode={selectedAirline?.id ?? ''}
                            selectedStation={selectedStation?.id ?? ''}
                            outboundTerminal={selectedTerminal?.id ?? ''}
                        />
                        <PadContainer cssClassModifiers={['pad-medium']} />
                        <Route path={`${path}/:flightId?`}>
                            <BagLocations
                                airlineCode={selectedAirline?.id ?? ''}
                                selectedStation={selectedStation?.id ?? ''}
                                outboundTerminal={selectedTerminal?.id ?? ''}
                            />
                        </Route>
                    </HorizontalFlex>
                </PadContainer>
            </HighlightedSection>
        </div>
    );
}
